export default __webpack_public_path__ + "media/images/logos/consultancy_logo_orange-e4ad8ebe7908d54daa7b11bf08fccd57.svg";